var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"manage-alert-member-must-label-key",style:({ width: _vm.width })},[(_vm.isMust)?_c('span',{staticClass:"manage-alert-member-must-label-star"},[_vm._v("*")]):_vm._e(),_vm._v(" "+_vm._s(_vm.title)+"： ")])
}
var staticRenderFns = []

export { render, staticRenderFns }